/* eslint-disable */
import { useEffect, useState } from 'react';
import { useTranslation } from '../../../locale/useTranslation';
import * as API from '../../../framework/API/api';
import { ENTITYNAME, MEDIACATEGORIES, TOAST_TYPES, VERSION_TYPE } from '../../../framework/constant/constant';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { ImageCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import { TimeCellWithOutFrames } from '../../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import RoundButton from '../../../framework/forms/helpercomponents/buttons/RoundButton';
import ContractCollectionSelection from '../../Contract/ContractCollectionSelection';
import { utility } from '../../../framework/utility/utilityProvider';
import ContentTreeViewForm from './ContentTreeViewForm';
import ManageContentEditPanel from '../manageContent/manageContentEditPanel';
import MultipleContentEditPanel from '../manageContent/multipleContentEditPanel';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { getter, process } from '@progress/kendo-data-query';
import PlaningFooter from '../../Planning/PlanningFooter';
import ToastNotification from '../../../components/ToastNotification';

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

const ContentTreeViewCollection = (props) => {

    const { showTitle = true } = props;

    const lang = useTranslation();

    const [selectedContentCategory, setSelectedContentCategory] = useState({});
    const [mediaData, setMediaData] = useState([]);
    const [filterdMediaData, setFilterdMediaData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showAttachMedia, setShowAttachMedia] = useState(false);
    const [parentEntityName, setParentEntityName] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const defaultMediaCategory = { _id: null, Description: "All" };
    const [entityName, setEntityName] = useState(null);
    const [mediaCategories, setMediaCategories] = useState([]);
    const [mediaCategory, setMediaCategory] = useState(defaultMediaCategory);
    const [sort, setSort] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [showMultiUpdate, setShowMultiUpdate] = useState(false);
    const [mediaCountData, setMediaCountData] = useState({});
    const isAutoCreateMAMAssetOnVersion = utility.isAutoCreateMAMAssetOnVersion();

    useEffect(() => {
        loadCombo();
    }, []);

    useEffect(() => {
        loadData();
    }, [selectedContentCategory]);

    const loadCombo = async () => {
        let mediaCategoryRes = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { Description: 1 } });
        mediaCategoryRes?.data?.unshift({ _id: null, Description: 'All' });
        setMediaCategories(mediaCategoryRes.data);
    }

    const loadData = async () => {
        if (!selectedContentCategory?._id) return;
        setIsLoading(true);
        const mediaRes = await API.getMediaByContentCategory({ contentCategoryId: selectedContentCategory?._id });
        const mediaCountContentCategory = await API.getMediaCountByContentCategory({ contentCategoryId: selectedContentCategory?._id });
        setMediaCountData(mediaCountContentCategory?.data);
        if (mediaRes.success) {
            setMediaData(mediaRes.data);
            setFilterdMediaData(mediaRes.data);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: mediaRes.message });
            setMediaData([]);
            setFilterdMediaData([]);
        }
        setIsLoading(false);
    }

    const applyFilters = (text, category) => {
        let filtered = mediaData;

        // Apply category filter
        if (category._id) {
            filtered = filtered.filter((item) =>
                item?.MediaEpisode?.MediaCategory?.SID == category?.SID
            );
        }

        // Apply search filter
        if (text) {
            filtered = filtered.filter((item) => {
                const ep = item?.MediaEpisode || {};
                return (
                    ep.Title?.toLowerCase().includes(text) ||
                    ep.Description?.toLowerCase().includes(text) ||
                    ep.MediaCategory?.Description?.toLowerCase().includes(text) ||
                    ep.AssetId?.toString()?.toLowerCase().includes(text)
                );
            });
        }

        setFilterdMediaData(filtered);
    };

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim().toLowerCase();
        setSearchText(text);
        applyFilters(text, mediaCategory);
    };

    const onItemClick = (e, dataItem) => {
        const mediaEpisode = dataItem?.MediaEpisode;
        if (!mediaCategory?._id) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.please_select_media_category_selection_error_message });
            return;
        }
        if (e.ctrlKey || e.metaKey) {
            if (selectedItems?.some(x => x?._id === mediaEpisode?._id)) {
                setSelectedItems(selectedItems.filter(x => x._id !== mediaEpisode._id));
            } else {
                setSelectedItems([...selectedItems, mediaEpisode]);
            }
        }
        else if (e.shiftKey && selectedItems.length > 0) {
            let startIndex = filterdMediaData.findIndex(x => x?.MediaEpisode?._id === selectedItems[0]._id);
            let endIndex = filterdMediaData.findIndex(x => x?.MediaEpisode?._id === mediaEpisode._id);

            if (startIndex !== -1 && endIndex !== -1) {
                let items;
                if (startIndex > endIndex) {
                    items = filterdMediaData.slice(endIndex, startIndex + 1).map(x => x.MediaEpisode);
                } else {
                    items = filterdMediaData.slice(startIndex, endIndex + 1).map(x => x.MediaEpisode);
                }
                setSelectedItems(items);
            }
        }
        else {
            if (selectedItems?.some(x => x?._id === mediaEpisode?._id)) {
                setSelectedItems([]);
            } else {
                setSelectedItems([mediaEpisode]);
            }
        }
    };

    const onChange = (e) => {
        const { value } = e.target;
        setMediaCategory(value);
        setEntityName(value?.SID == MEDIACATEGORIES.Series ? ENTITYNAME.Series :
            value?.SID == MEDIACATEGORIES.Season ? ENTITYNAME.Season :
                ENTITYNAME.MediaEpisode);
        setSelectedItems([]);
        setSort([]);
        setShowMultiUpdate(false);
        applyFilters(searchText, value);
    };

    const handleUpdateMultiple = () => {
        if (!mediaCategory?._id) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.please_select_media_category_selection_error_message });
            return;
        }
        setShowMultiUpdate(true);
    }

    const handleCreateMAMAssetAndWO = async () => {
        if (!mediaCategory?._id) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.please_select_media_category_selection_error_message });
            return;
        }
        console.log(selectedItems);
        console.log(filterdMediaData);
        let payload = {
            mediaIds: selectedItems?.length > 0 ? selectedItems.map(x => x?.MediaEpisode?._id) : filterdMediaData.map(x => x.MediaEpisode?._id),
            entityName: mediaCategory?.SID == MEDIACATEGORIES.Series ? ENTITYNAME.Series : mediaCategory?.SID == MEDIACATEGORIES.Season ? ENTITYNAME.Season : ENTITYNAME.MediaEpisode,
            versionType: VERSION_TYPE.Linear,
            // transmissionType : ingestMAMObj.transmissionType,
            // ingestPrototype: ingestMAMObj.ingestProtoType
        }
        console.log(payload);
        let res = await API.createMAMandWoFromEpisodes(payload);
        console.log(res);
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setSelectedItems([]);
    }

    // Render media list
    const renderMediaList = () => {
        const FullCenter = ({ children }) => (
            <div style={{
                height: 'calc(100vh - 294px)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#999',
                textAlign: 'center',
                padding: '20px'
            }}>
                {children}
            </div>
        );

        const totalCount = mediaCountData ? Object.values(mediaCountData).reduce((a, b) => a + b, 0) : 0;

        return (
            <div style={{ padding: '15px' }}>
                <div style={{
                    borderBottom: '2px solid #ddd',
                    paddingBottom: '10px',
                    marginBottom: '15px'
                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>
                            {selectedContentCategory?._id && <>
                                <RoundButton title={lang.update_all_media_by_category_button_tooltip} icon="edit" onClick={handleUpdateMultiple} />
                                <RoundButton title={lang.attach_media_button_tooltip} icon="link" onClick={() => setShowAttachMedia(true)} />
                                {isAutoCreateMAMAssetOnVersion && <RoundButton title={lang.create_mamasset_and_wo_button_tooltip} icon="file-o" onClick={handleCreateMAMAssetAndWO} />}
                            </>}{lang.media_content_header}
                        </h3>
                        {selectedContentCategory?.Name && (
                            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                {selectedContentCategory.Name}({totalCount})
                            </span>
                        )}
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <p style={{ margin: '5px 0 0 0', fontSize: '13px', color: '#666' }}>
                            {filterdMediaData.length} {filterdMediaData.length === 1 ? 'item' : 'items'} found
                        </p>

                        {mediaData.length > 0 &&
                            <div>
                                <label className='mr-2'>{lang.media_category_label} </label>
                                <DropDownList
                                    style={{ width: (showMultiUpdate || selectedItems.length > 0) ? "120px" : "200px", marginRight: "10px" }}
                                    data={mediaCategories}
                                    dataItemKey="_id"
                                    textField="Description"
                                    value={mediaCategory}
                                    onChange={onChange}
                                    name="mediaCategory"
                                />
                                <input
                                    type="text"
                                    className="form-control form-control-sm shadow-inset-2 pt-0 pb-0"
                                    style={{ width: (showMultiUpdate || selectedItems.length > 0) ? "180px" : "270px" }}
                                    id="searchInput"
                                    placeholder={lang.search_button_text}
                                    onChange={onSearch}
                                    onFocus={(e) => {
                                        if (props.setOutSideFocus) {
                                            props.setOutSideFocus(true);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        if (props.setOutSideFocus) {
                                            props.setOutSideFocus(false);
                                        }
                                    }}
                                />
                                <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                                    <span className="input-group-text" style={{ padding: "4px 10px", fontSize: "14px" }}>
                                        <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                    </span>
                                </button>
                            </div>
                        }
                    </div>
                </div>

                <div className="media-list" style={{ display: 'grid' }}>

                    {/* LOADING */}
                    {isLoading && (
                        <Loader />
                    )}

                    {/* NOTHING SELECTED */}
                    {!isLoading && !selectedContentCategory?._id && (
                        <FullCenter>
                            <i className="fa fa-info-circle" style={{ fontSize: '30px', marginBottom: '8px' }}></i>
                            <p>{lang.select_a_category_from_the_tree_to_view_media_message}</p>
                        </FullCenter>
                    )}

                    {/* NO MEDIA FOUND */}
                    {!isLoading && selectedContentCategory?._id && filterdMediaData.length === 0 && (
                        <FullCenter>
                            <i className="fa fa-folder-open" style={{ fontSize: '60px', marginBottom: '8px' }}></i>
                            <p>{lang.no_media_found_for_this_category_message}</p>
                            <small>{lang.try_selecting_another_category_message}</small>
                        </FullCenter>
                    )}

                    {/* GRID VIEW */}
                    {!isLoading && selectedContentCategory?._id && filterdMediaData.length > 0 && (
                        <Grid
                            style={{ height: 'calc(100vh - 315px)', overflow: 'auto' }}
                            resizable={true}
                            sortable={{
                                allowUnsort: true,
                                mode: 'multiple'
                            }}
                            sort={sort}
                            onSortChange={(e) => {
                                setSort(e.sort);
                            }}
                            data={process(
                                filterdMediaData.map(data => ({
                                    ...data,
                                    [SELECTED_FIELD]: selectedItems.some(selectedItem => selectedItem?._id === data?.MediaEpisode?._id)
                                })),
                                { sort: sort }
                            )}
                            selectedField={SELECTED_FIELD}
                            selectable={{
                                enabled: true,
                                mode: {
                                    value: "multiple",
                                },
                            }}
                            onSelectionChange={(event) => {
                                let rowIndex = event.startRowIndex;
                                let dataItem = event.dataItems[rowIndex];
                                onItemClick(event, dataItem);
                            }}
                            dataItemKey={DATA_ITEM_KEY}
                        >
                            <GridColumn field="MediaEpisode.ImageUrl" title={lang.image_column} cell={ImageCell} width="80px" />
                            <GridColumn field="MediaEpisode.Title" title={lang.title_column} width={"220px"} />
                            <GridColumn field="MediaEpisode.Description" title={lang.description_column} width={"220px"} />
                            <GridColumn field="MediaEpisode.MediaCategory.Description" title={lang.media_category_column} width={"130px"} />
                            <GridColumn field="MediaEpisode.AssetId" title={lang.assetId_column} width={"120px"} />
                            <GridColumn field="MediaEpisode.Duration" title={lang.duration_column} cell={TimeCellWithOutFrames} width={"120px"} />
                        </Grid>
                    )}

                </div>
            </div>
        );
    };

    const handleAttachMedia = async (dataList) => {
        let newData = utility.checkDuplicateInData(dataList, mediaData.map(x => x.MediaEpisode), "AssetId");
        if (newData?.length == 0) return;

        let res = await API.updateMediaByContentCategory({ mediaIds: newData.map(x => ({ _id: x?._id, SID: x?.SID })), entityName: parentEntityName, contentCategory: { _id: selectedContentCategory?._id, Name: selectedContentCategory?.Name, parent: selectedContentCategory?.parent } });
        console.log(res);

        if (res.success) {
            setIsLoading(true);
            try {
                const mediaRes = await API.getMediaByContentCategory({
                    contentCategoryId: selectedContentCategory._id
                });
                setMediaData(mediaRes?.data ?? []);
                setFilterdMediaData(mediaRes?.data ?? []);
            } catch (error) {
                console.error('Error reloading media:', error);
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to reload media list" });
            } finally {
                setIsLoading(false);
                setShowAttachMedia(false);
                setSelectedItems([]);
                setShowMultiUpdate(false);
                setMediaCategory(defaultMediaCategory);
            }
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to reload media list" });
        }
    }

    const handleSingleSelectUpdatedData = (data = {}) => {

        if (!data || Object.keys(data).length === 0) return setSelectedItems([]);

        const updateList = (list) =>
            list.map((item) =>
                item?.MediaEpisode?._id === data._id
                    ? {
                        ...item,
                        ...data?.MetaData,
                        MediaEpisode: data,
                        [SELECTED_FIELD]: !item[SELECTED_FIELD],
                    }
                    : item
            );

        setMediaData(updateList(mediaData));
        setFilterdMediaData(updateList(filterdMediaData));
    };

    const handleMulitpleSelectUpdatedData = (data = []) => {

        if (data?.length === 0) return setSelectedItems([]);

        const selectedIds = new Set(data.map(d => d._id));

        const updateList = (list = []) =>
            list.map((item) =>
                selectedIds.has(item?.MediaEpisode?._id)
                    ? {
                        ...item,
                        MediaEpisode: data.find(
                            d => d._id === item?.MediaEpisode?._id
                        ),
                        [SELECTED_FIELD]: !item[SELECTED_FIELD],
                    }
                    : item
            );

        setMediaData(updateList(mediaData));
        setFilterdMediaData(updateList(filterdMediaData));
        setSelectedItems([]);
    };


    const handleSelectedCategory = (category) => {
        setSelectedContentCategory(category);
        setSelectedItems([]);
        setMediaCategory(defaultMediaCategory);
        setSort([]);
    }

    const hasMediaCount = mediaCountData && Object.keys(mediaCountData)?.length > 0;

    const onCloseMultiForm = (isRefresh = false) => {
        setShowMultiUpdate(false);
        if (isRefresh) {
            setMediaCategory(defaultMediaCategory);
            isRefresh && loadData();
        }
    }

    return (
        <>
            {showTitle && (
                <h1 className="page-title txt-color-bludeDark">
                    <i
                        className="fa fa-table marlr"
                        style={{ fontSize: "20px", color: "GrayText" }}
                    ></i>
                    <span>{lang.content_tree_view_page_breadcrumb}</span>
                </h1>
            )}
            <div className='row' style={{ margin: 0 }}>
                <div className={(showMultiUpdate || selectedItems.length > 0) ? 'col-2' : 'col-3'}>
                    <ContentTreeViewForm height="calc(100vh - 150px)" handleSelectedCategory={handleSelectedCategory} />
                </div>
                <div className={(showMultiUpdate || selectedItems.length > 0) ? 'col-6' : 'col-9'}>
                    <div style={{
                        border: '1px solid #ddd',
                        backgroundColor: '#fff',
                        borderRadius: '4px',
                        height: 'calc(100vh - 150px)',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#888 #f1f1f1'
                    }}>
                        <style>
                            {`
                                .col-8 > div::-webkit-scrollbar {
                                    width: 8px;
                                }
                                .col-8 > div::-webkit-scrollbar-track {
                                    background: #f1f1f1;
                                    border-radius: 4px;
                                }
                                .col-8 > div::-webkit-scrollbar-thumb {
                                    background: #888;
                                    border-radius: 4px;
                                }
                                .col-8 > div::-webkit-scrollbar-thumb:hover {
                                    background: #555;
                                }
                            `}
                        </style>
                        {renderMediaList()}

                        {/* footer */}
                        <div className="row" style={{ position: "sticky", bottom: 0, backgroundColor: "#3a3633", borderTop: "1px solid #dcdcdc", padding: hasMediaCount ? "8px 12px" : "17.7px 12px", fontSize: "13px" }}>
                            <div className="col-12" style={{ display: "flex", alignItems: "center", gap: "22px" }}>
                                {hasMediaCount &&
                                    Object.entries(mediaCountData).map(([label, count]) => (
                                        <div key={label} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                                            <span style={{ fontSize: "13px", color: "#ffffff", marginRight: "4px" }}>{label}</span>
                                            <span style={{ fontSize: "13px", fontWeight: "600", color: "#ffffff" }}> {count ?? 0}</span>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col'>
                    {selectedItems.length == 1 && <ManageContentEditPanel mainStyle={{ top: 0, height: "100%", width: "100%" }} mediaCategory={mediaCategory} selectedItem={selectedItems[0]} entityName={entityName} transcodeStatus={selectedItems[0]?.latestTranscodeStatus?.Description ?? 'N/A'} setGridData={(data) => handleSingleSelectUpdatedData(data?.length > 0 ? data[0] : {})} gridData={selectedItems} setSelectedItem={handleSingleSelectUpdatedData} />}
                    {(showMultiUpdate || selectedItems.length > 1) && <MultipleContentEditPanel onClose={onCloseMultiForm} mainStyle={{ top: 0, height: "100%", width: "100%", right: showMultiUpdate && 0 }} entityName={entityName} mediaCategory={mediaCategory} selectedItems={selectedItems} setSelectedItems={handleMulitpleSelectUpdatedData} gridData={[]} setGridData={() => { }} contentCategory={selectedContentCategory} />}
                </div>
            </div>
            {showAttachMedia && <ContractCollectionSelection addButtonTitle={lang.select_button_text} title={lang.media_library_dialog_header} setDataList={handleAttachMedia} setParentEntityName={setParentEntityName} closeForm={() => setShowAttachMedia(false)} width="50vw" isFromContentTreeViewCollection={true} />}
        </>
    );
};

export default ContentTreeViewCollection;
